var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "inline-flex cursor-pointer",
    on: {
      "click": _vm.setNewSortOrder
    }
  }, [_vm._t("default"), _c('Icon', {
    staticClass: "ml-1",
    class: _vm.classes,
    attrs: {
      "name": _vm.icon,
      "size": 4
    }
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }